var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import { build } from "../Models/SiteMap.ts";
var PageHeader = /** @class */ (function (_super) {
    __extends(PageHeader, _super);
    function PageHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PageHeader.prototype, "siteMap", {
        get: function () { return build(this.pages, function (p) { return p.showInFooter === true; }); },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: String })
    ], PageHeader.prototype, "text", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], PageHeader.prototype, "pages", void 0);
    PageHeader = __decorate([
        Component({
            name: "PageFooter"
        })
    ], PageHeader);
    return PageHeader;
}(Vue));
export default PageHeader;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App/PageFooter.vue
// module id = 870
// module chunks = 24